import React from 'react';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';
import get from 'lodash/get';

import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import Input from 'components/Input';
import Select from 'components/Select';

const PersonalInformationContainer = styled.div`
  .personalInformationCardContent {
    display: flex;
    flex-direction: column;
    margin-left: 41px;
    margin-right: 50px;
  }

  .row {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 3vh;
  }

  @media (min-width: 801px) {
    .soloRow .inputContainer {
      width: 100%;
    }

    .inputContainer {
      width: calc((100% - 30px) / 2);
    }

    .inputContainer:not(:last-child) {
      margin-right: 30px;
    }

    > div {
      min-height: 450px !important;
      background-color: white;
    }
  }

  @media (max-width: 800px) {
    .soloRow {
      width: 100%;
      margin-bottom: 3vh !important;
    }

    .row {
      flex-direction: column;
      margin-bottom: 0px;
    }
    .inputContainer {
      width: 100%;
      margin-right: 0px;
      margin-bottom: 3vh;
    }
  }

  hr {
    color: #adb5bd;
    opacity: 0.2;
    width: 100%;
    margin-bottom: 3vh;
  }
`;

const findLabel = (optionsPosition, id) => {
  const position = optionsPosition.find((item) => item.id === id);
  return position ? position.name : '';
};

const PersonalInformation = ({ data, onChange, optionsPosition }) => {
  return (
    <PersonalInformationContainer>
      <Card className="adminCard">
        <CardHeader
          title={I18n.t('admin.personalInformations')}
          icon="espace"
          iconContainer
          iconPosition="left"
          textTransform="normal"
        />

        <div className="personalInformationCardContent">
          <div className="row">
            <div className="inputContainer">
              <Input
                styles={`width:100%`}
                label={I18n.t('admin.personalInfoInputs.firstname')}
                onChange={(value) => onChange('firstname', value)}
                value={get(data, 'firstname', '')}
              />
            </div>
            <div className="inputContainer">
              <Input
                styles={`width:100%`}
                label={I18n.t('admin.personalInfoInputs.lastname')}
                onChange={(value) => onChange('lastname', value)}
                value={get(data, 'lastname', '')}
              />
            </div>
          </div>
          <div className="row">
            <div className="inputContainer">
              <Input
                styles={`width:100%`}
                label={I18n.t('admin.personalInfoInputs.email')}
                disabled
                onChange={(value) => onChange('email', value)}
                value={get(data, 'email', '')}
              />
            </div>
            <div className="inputContainer">
              <Input
                styles={`width:100%`}
                label={I18n.t('admin.personalInfoInputs.phone')}
                onChange={(value) => onChange('phone', value)}
                value={get(data, 'phone', '')}
              />
            </div>
          </div>
          <div className="row soloRow">
            <div className="inputContainer">
              <Select
                label={I18n.t('admin.personalInfoInputs.position')}
                options={optionsPosition.map((item) => ({
                  value: item.id,
                  label: item.name
                }))}
                dropdownProps={{ styles: `margin-left:-25px` }}
                customStyles={{
                  container: {
                    fontSize: 11
                  },
                  control: {
                    fontSize: 11
                  },
                  valueContainer: {
                    fontSize: 11
                  },
                  placeholder: {
                    fontSize: 11
                  }
                }}
                onChange={(value) => onChange('job', value.value)}
                value={
                  get(data, 'job', null) && {
                    value: data.job,
                    label: findLabel(optionsPosition, data.job)
                  }
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="inputContainer">
              <Input
                label={I18n.t('admin.personalInfoInputs.linkedinId')}
                onChange={(value) => onChange('linkedin', value)}
                value={get(data, 'linkedin', '')}
              />
            </div>
          </div>
        </div>
      </Card>
    </PersonalInformationContainer>
  );
};

export default PersonalInformation;
